import { Injectable } from '@angular/core';

@Injectable()
export class RequestParams {
    get params() {
        if (typeof location === 'undefined')
            return {};

        let args: any = {};
        let parts = location.search
            .substring(1)
            .split(/&/g)
            .map(x =>
                x.split(/=/)
                    .map(x => decodeURIComponent(x.replace(/\+/g, '%20')))
            )
            .forEach(x => args[x[0]] = x[1])
            ;

        return args;
    }
}